export default {
  "content": "<path d=\"M7 7h10c.55 0 1-.45 1-1s-.45-1-1-1H7c-.55 0-1 .45-1 1s.45 1 1 1z\" fill=\"#C70A14\"/><path d=\"M9.51 9.02H4.95c-.54 0-.99-.4-1.05-.94l-.67-5.96A2.346 2.346 0 00.96.03L0 0l.78 9.39A2.849 2.849 0 003.64 12H5v5H3c-.55 0-1 .45-1 1s.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1H7v-5h2.51c.82 0 1.49-.67 1.49-1.49s-.67-1.49-1.49-1.49zM23.05.03c-1.17.04-2.14.93-2.27 2.09l-.67 5.96c-.06.54-.51.94-1.05.94H14.5c-.82 0-1.49.67-1.49 1.49S13.68 12 14.5 12h2.51v5h-2c-.55 0-1 .45-1 1s.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1h-2v-5h1.36a2.87 2.87 0 002.86-2.61L24.01 0l-.95.03h-.01z\" fill=\"#C70A14\"/>",
  "attrs": {
    "width": "25",
    "height": "19",
    "viewBox": "0 0 25 19",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};